import React from 'react';
import PropTypes from 'prop-types';

import Exchange from '../../../models/Exchange';

import MutualExchangePopup from './MutualExchangePopup';
import Availability from '../../../models/Availability';

const ModifyMutualExchangeModalWrapper = ({
    convExchanges,
    convId,
    interlocutorFirstName,
    updateLoadingState,
    availabilities,
    interlocutorAvailabilities,
    userTotalGp,
    isCollection,
    fetchConversation
}) => {
    const [showMutualModificationFormModal, setShowMutualModificationFormModal] = React.useState(true);

    const toggleMutualExchangeModificationFormModal = () => {
        setShowMutualModificationFormModal((currentState) => !currentState);
    };

    return (
        <MutualExchangePopup
            showMutualModificationFormModal={showMutualModificationFormModal}
            closeMutualModificationFormModal={toggleMutualExchangeModificationFormModal}
            convExchanges={convExchanges}
            convId={convId}
            interlocutorFirstName={interlocutorFirstName}
            updateLoadingState={updateLoadingState}
            availabilities={availabilities}
            interlocutorAvailabilities={interlocutorAvailabilities}
            userTotalGp={userTotalGp}
            isCollection={isCollection}
            fetchConversation={fetchConversation}
        />
    );
};

ModifyMutualExchangeModalWrapper.propTypes = {
    interlocutorFirstName: PropTypes.string.isRequired,
    convExchanges: PropTypes.arrayOf(PropTypes.instanceOf(Exchange)).isRequired,
    convId: PropTypes.number.isRequired,
    updateLoadingState: PropTypes.func.isRequired,
    availabilities: PropTypes.arrayOf(PropTypes.instanceOf(Availability)).isRequired,
    interlocutorAvailabilities: PropTypes.arrayOf(PropTypes.instanceOf(Availability)).isRequired,
    userTotalGp: PropTypes.number.isRequired,
    isCollection: PropTypes.bool.isRequired,
    fetchConversation: PropTypes.func.isRequired
};

export default ModifyMutualExchangeModalWrapper;
